(function(Cobalt) {
    var Device = /** @class */ (function () {
        function Device() {
        }
        Object.defineProperty(Device, "Properties", {
            get: function () {
                return {
                    osx: this.OSX,
                    ios: this.iOS,
                    iphone: this.iPhone,
                    ipad: this.iPad,
                    android: this.Android,
                    blackberry: this.BlackBerry,
                    windows: this.Windows,
                    mobile: this.Mobile,
                    tablet: this.Tablet,
                    portrait: this.Portrait,
                    landscape: this.Landscape
                };
            },
            enumerable: true,
            configurable: true
        });
        Device.ResponsiveCookieName = function () {
            return "ResponsiveSwitch.DesktopMode";
        };
        Device.Find = function (needle) {
            return this.UserAgent.indexOf(needle) !== -1;
        };
        Object.defineProperty(Device, "OSX", {
            get: function () {
                return this.Find('mac os x') && !this.iOS;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Device, "iOS", {
            get: function () {
                return this.iPhone || this.iPod || this.iPad;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Device, "iPhone", {
            get: function () {
                return this.Find('iphone');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Device, "iPod", {
            get: function () {
                return this.Find('ipod');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Device, "iPad", {
            get: function () {
                return this.Find('ipad');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Device, "Android", {
            get: function () {
                return this.Find('android');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Device, "AndroidPhone", {
            get: function () {
                return this.Find('android') && this.Find('mobile');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Device, "AndroidTablet", {
            get: function () {
                return this.Find('android') && !this.Find('mobile');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Device, "BlackBerry", {
            get: function () {
                return this.Find('blackberry') || this.Find('bb10') || this.Find('rim');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Device, "Windows", {
            get: function () {
                return this.Find('windows');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Device, "WindowsPhone", {
            get: function () {
                return this.Windows && this.Find('phone');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Device, "WindowsTablet", {
            get: function () {
                return this.Windows && this.Find('touch');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Device, "Mobile", {
            get: function () {
                return this.AndroidPhone || this.iPhone || this.iPod || this.WindowsPhone;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Device, "Tablet", {
            get: function () {
                return this.AndroidTablet || this.iPad || this.WindowsTablet;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Device, "Desktop", {
            get: function () {
                return !this.Mobile && !this.Tablet;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Device, "Portrait", {
            get: function () {
                return window.innerHeight > window.innerWidth;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Device, "Landscape", {
            get: function () {
                return !this.Portrait;
            },
            enumerable: true,
            configurable: true
        });
        Device.AddClasses = function () {
            for (var i in this.Properties) {
                if (this.Properties.hasOwnProperty(i) && this.Properties[i] && !this.Html.hasClass(i)) {
                    $('html').addClass(i);
                }
            }
        };
        Device.RemoveClasses = function () {
            for (var i in this.Properties) {
                if (this.Properties.hasOwnProperty(i)) {
                    $('html').removeClass(i);
                }
            }
        };
        /**
         A simple function that handles the requirements for switching from
         our responsive design to traditional desktop design
         */
        Device.initResponsiveLayout = function () {
            // grab the response cookie if it exists, if not set it to default of mobile view
            var rsCookie = $.cookie(Device.ResponsiveCookieName());
            if (!rsCookie) {
                $.cookie(Device.ResponsiveCookieName(), 1, { expires: 360, path: '/' });
                rsCookie = $.cookie(Device.ResponsiveCookieName());
            }
            // hide the footer link
            if (rsCookie == "1") {
                $('#responsive-footer-button').css("display", "none");
                // alternative:
                // $('#responsive-footer-button').addClass('hidden');
            }
            else {
                $('#responsive-footer-button').css("display", "block");
                // alternative:
                // $('#responsive-footer-button').removeClass('hidden');
            }
            // whenever the switch button is clicked, switch the responsive cookie value, then reload the page
            // no need to create a controller action and make the server do anything with a different request when we can just do it here.
            $('.rs-link').click(function (e) {
                e.preventDefault();
                switch (rsCookie) {
                    case "0":
                        $.cookie(Device.ResponsiveCookieName(), 1, { expires: 360, path: '/' });
                        break;
                    case "1":
                        $.cookie(Device.ResponsiveCookieName(), 0, { expires: 360, path: '/' });
                        break;
                }
                location.reload();
            });
        };
        Device.resize = function (orientation) {
            if (orientation == 'portrait' && !this.Portrait) {
                $('html').removeClass('portrait').addClass('landscape');
            }
            else if (orientation == 'landscape' && !this.Landscape) {
                $('html').removeClass('landscape').addClass('portrait');
            }
        };
        Device.initialize = function () {
            var _this = this;
            Device.initResponsiveLayout();
            this.Html = $('html');
            this.AddClasses();
            var orientation = $('html').hasClass('portait') ? 'portrait' : 'landscape';
            $(window).on('resize', function () {
                clearTimeout(_this.resizeTimer);
                _this.resizeTimer = setTimeout(function () { Device.resize(orientation); }, 100);
            });
        };
        Device.UserAgent = window.navigator.userAgent.toLowerCase();
        return Device;
    }());

    Cobalt.Device = Device;
})(Cobalt || (window.Cobalt = {}));




// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Device.js